module.exports = __webpack_public_path__ + "img/chrome-step-2.bcfd4d0d.svg";